import React, { useMemo, useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import debounce from "lodash.debounce";
import { X } from "react-feather";

export default function Toolbar({
  search,
  setSearch,

  selectedCategory,
  handleCategoryChange,

  selectedSubCategory,
  handleSubCategoryChange,

  categories,
  rawCategories,
  loadingCategories,
  categoriesError,
  onRefetch,
}) {
  const [searchLoading, setSearchLoading] = useState(false);

  // ✅ local input (debounce-д зориулж)
  const [searchInput, setSearchInput] = useState(search || "");

  useEffect(() => {
    setSearchInput(search || "");
  }, [search]);

  const debouncedCommit = useMemo(() => {
    return debounce((value) => {
      setSearch(value);
      setSearchLoading(false);
    }, 500);
  }, [setSearch]);

  useEffect(() => {
    return () => debouncedCommit.cancel();
  }, [debouncedCommit]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    setSearchLoading(true);
    debouncedCommit(value); // ✅ зөвхөн debounce-р гадна search өөрчилнө
  };

  const clearSearch = () => {
    debouncedCommit.cancel();
    setSearchInput("");
    setSearch("");
    setSearchLoading(false);
  };

  const subCategoryOptions = useMemo(() => {
    if (!selectedCategory) return [];
    const parent = rawCategories?.find(
      (p) => String(p.id) === String(selectedCategory)
    );
    const children = parent?.children || [];
    return children.map((c) => ({ value: String(c.id), label: c.name }));
  }, [rawCategories, selectedCategory]);

  const showSub = selectedCategory && subCategoryOptions.length > 0;

  return (
    <div className="page-title-box">
      <div className="page-title-right d-flex align-items-center mb-2 gap-2">
        {/* SEARCH */}
        <div style={{ position: "relative", width: "200px" }}>
          <Form.Control
            type="text"
            placeholder="Хайх..."
            value={searchInput}
            onChange={handleSearchChange}
            className="bg-white"
            style={{ paddingRight: "30px" }}
          />
          {(searchLoading || searchInput) && (
            <div
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: searchLoading ? "default" : "pointer",
                color: "#999",
              }}
              onClick={!searchLoading ? clearSearch : undefined}
            >
              {searchLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    width: "16px",
                    height: "16px",
                    color: "#999",
                    borderWidth: "1px",
                  }}
                />
              ) : (
                <X size={16} />
              )}
            </div>
          )}
        </div>

        {/* PARENT CATEGORY */}
        <Form.Select
          value={selectedCategory || ""}
          onChange={(e) => {
            const value = e.target.value === "" ? null : e.target.value;
            handleCategoryChange(value);
            handleSubCategoryChange(null); // ✅ reset sub
          }}
          className="me-2"
          style={{ width: "200px" }}
          disabled={loadingCategories || !!categoriesError}
        >
          {loadingCategories && <option>Ангилал татаж байна...</option>}

          {!loadingCategories &&
            !categoriesError &&
            categories.map((cat) => (
              <option key={cat.value ?? "all"} value={cat.value || ""}>
                {cat.label}
              </option>
            ))}

          {categoriesError && <option disabled>{categoriesError}</option>}
        </Form.Select>

        {/* SUB CATEGORY */}
        <Form.Select
          value={selectedSubCategory || ""}
          onChange={(e) => {
            const value = e.target.value === "" ? null : e.target.value;
            handleSubCategoryChange(value);
          }}
          className="me-2"
          style={{ width: "200px" }}
          disabled={!showSub || loadingCategories || !!categoriesError}
        >
          <option value="">
            {showSub ? "Дэд ангилал (бүгд)" : "Дэд ангилал байхгүй"}
          </option>

          {showSub &&
            subCategoryOptions.map((sc) => (
              <option key={sc.value} value={sc.value}>
                {sc.label}
              </option>
            ))}
        </Form.Select>

        <Button variant="primary" className="border" onClick={onRefetch}>
          <i className="mdi mdi-autorenew" />
        </Button>
      </div>
    </div>
  );
}
